import React, {Component} from 'react';
import {AJAX, cross_form_errors, hidePreloader, showPreloader} from "../functions";
import Popup from "./Popup";
import {showPopupWithGoBack} from "./PopupWithGoBack";

class ReasonPopup extends Component {

    constructor(props) {
        super(props);
        this.state = {reason: '', errors: {}};
        this.handleCloseLP = this.handleCloseLP.bind(this);
        this.handleChangeInput = this.handleChangeInput.bind(this);
        this.decline = this.decline.bind(this);
    }

    handleCloseLP() {
        this.props.handleClose();
    }

    handleChangeInput(event) {
        this.setState({reason: event.target.value.trim()});
    }


    decline(event) {
        event.preventDefault();
        let t = this;

        let params = {
            reason: t.state.reason,
            uuid: t.props.uuid,
            action: 'api/booking/decline-alternative'
        };

        AJAX(bm_ajax_url, 'POST', params, {
            response_json: true,
            func_waiting: showPreloader,
            func_callback: function (resp) {

                hidePreloader();
                if (resp.success === 1) {
                    t.setState({success: true});
                    t.props.handleClose();
                } else {
                    if (resp.error) {
                        showPopupWithGoBack(resp.error);
                    }
                    if (resp.errors !== undefined && resp.errors.form !== undefined) {
                        t.setState({errors: resp.errors});
                    }
                    t.props.handleSetSuccessPage(resp.messages);
                    t.props.handleClose();
                }
            },
            func_error: function (resp) {
                hidePreloader();
                showPopupWithGoBack(resp.message);
                t.props.handleClose();
            }
        });
    }


    render() {
        return (
            <Popup open={this.props.show}
                   modal
                   lockScroll
                   closeOnDocumentClick={false}
                   className={"bm-modal"}
            >
                <>
                    <button type="button" className="close" aria-label="Close" onClick={this.handleCloseLP}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <div className="clearfix" />
                    <div className="col-12 text-center form-inputs">
                        <form onSubmit={this.decline}>
                            <label>Write reason to decline</label>
                            <textarea name={'reason'} hanldeChange={this.handleChangeInput} value={this.state.email} />
                            <div className="d-flex justify-content-center align-items-center">
                                <input type="submit" style={{marginRight:"10px"}} className="btn btn-danger" value="Decline"/>
                                <input type="button" className="btn btn-warning" value="Close" onClick={this.handleCloseLP} />
                            </div>
                        </form>
                    </div>
                </>
            </Popup>
        );
    }
}

export default ReasonPopup;